import {Component, OnInit} from '@angular/core';
import {TasksService} from '../tasks.service';
import {NgForm} from '@angular/forms';
import {format} from 'date-fns';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'app-tasks-list',
    templateUrl: './tasks-list.component.html',
    styleUrls: ['./tasks-list.component.scss']
})
export class TasksListComponent implements OnInit {
    type = 'tasks';
    assignedTasks;
    createdTasks;
    today = new Date();
    currentColor = '#D32F2F';
    selectedState: string;
    recivedTasksLoaded = false;
    createdTasksLoaded = false;
    users: object = [];
    showLoader = true;
    task: any = [];
    formResponse: boolean;
    formSent: boolean;

    constructor(private tasksService: TasksService,
                private snackBar: MatSnackBar) {

        this.tasksService.taskListSubject.subscribe(res => {
            this.getTasks(res);
        });

        this.getCrmUsers()
    }

    ngOnInit() {
        this.getTasks('assigned');
        this.getTasks('created');
    }

    changeState() {
        this.currentColor = this.selectedState;
    }

    getCrmUsers() {
        this.tasksService.getAllCRMUsers().subscribe(users => {
            this.users = users;
        })
    }

    getTasks(type) {
        if (type === 'assigned') {
            this.tasksService.getMyAssignedTasks(this.type).subscribe(tasks => {
                this.assignedTasks = tasks;
                this.recivedTasksLoaded = true;
                this.showLoader = false;
            })
        }
        if (type === 'created') {
            this.tasksService.getMyCreatedTasks(this.type).subscribe(tasks => {
                this.createdTasks = tasks;
                this.createdTasksLoaded = true;
                this.showLoader = false;
            })
        }
    }

    onSubmit(taskForm: NgForm) {
        //
        this.task = {
            senderUserId: '',
            receiverUserId: taskForm.value.receiverUserId,
            messageDetail: taskForm.value.messageDetail,
            messageTitle: taskForm.value.messageTitle,
            deadline: taskForm.value.deadline,
            labelTask: taskForm.value.labelTask,
            attachments: [],
            additionDate: undefined,
            status: 'Nou',
            labelColour: taskForm.value.labelColour,
            taskMessages: []
        }


        this.tasksService.createTask(this.task, this.type).subscribe(taskResult => {

            if (taskResult['success']) {

                this.formResponse = true;
                this.formSent = true;

                setTimeout(() => {
                    this.formSent = false;
                }, 4000);

                this.tasksService.taskListSubject.next('assigned');
                this.getTasks('assigned');
                this.getTasks('created');

                taskForm.resetForm();

            } else {
                this.formResponse = false;
                this.formSent = true;

                setTimeout(() => {
                    this.formSent = false;
                }, 4000);

            }
        }, error => {
            this.formResponse = false;
            this.formSent = true;
            setTimeout(() => {
                this.formSent = false;
            }, 4000);
        })

    }

}
